import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import LoginLink from "@components/login-link";
import TrialLink from "@components/trial-link";
import React from "react";
var GuestMessage = function(param) {
    var _data = param.data, headers = _data.headers, messageText = _data.messageText, trialLink = _data.trialLink, loginLink = _data.loginLink;
    return /*#__PURE__*/ _jsxs("div", {
        className: "mt-4",
        children: [
            /*#__PURE__*/ _jsx("div", {
                children: headers
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "my-4 w-full lg:w-2/4",
                children: messageText
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "grid grid-cols-1 md:grid-cols-2 w-full lg:w-2/4 mb-4",
                children: [
                    /*#__PURE__*/ _jsx(TrialLink, _object_spread({}, trialLink)),
                    /*#__PURE__*/ _jsx(LoginLink, _object_spread({}, loginLink))
                ]
            })
        ]
    });
};
export default GuestMessage;
